<template lang="pug">
.debug-login-student
  .debug-login-student__input-area
    .debug-login-student__input-area__header ログイン
    .validate(v-if='errorMessages.length > 0')
      p.validate__message(v-for='errorMessage in errorMessages') {{ errorMessage }}
    .debug-login-student__input-area__bcbt-code
      p BCBTコード
      input(v-model='bcbtCode')
    .debug-login-student__input-area__password
      p パスワード
      input(type='password', v-model='password')
    a.debug-login-student__input-area__button(@click='submitLogin') ログイン
</template>

<script lang="ts">
import { Component, Mixins } from 'vue-property-decorator'
import LoginMethods from '@/mixins/LoginMethods'

@Component
export default class DebugLoginStudent extends Mixins(LoginMethods) {
  private bcbtCode = ''
  private password = ''

  private async submitLogin() {
    this.$loading.start()
    // 生徒権限ログイン
    await this.studentLogin(this.bcbtCode, this.password)
    this.$loading.complete()
  }

  /**
   * 遷移先ページをオーバーライド
   */
  public topPagePath(): string {
    return '/debug'
  }
}
</script>

<style lang="stylus" scoped>
.debug-login-student
  margin 100px
  width 320px

  &__input-area
    margin-top 30px
</style>
